import { TableContext } from "@stenajs-webui/grid";
import { batch } from "react-redux";
import { AppThunk } from "@/redux/RootReducer";
import { BulkUpdateRatesFormModel } from "../../bulk-update-rates/models/BulkUpdateRatesFormModel";
import { BulkEditRatesTableColumn } from "../config/BulkEditRatesTableConfig";
import { raisePriceForRouteAgreementPrice } from "../hooks/UseBulkUpdateRatesLogic";
import { fetchBulkEditRatesActualChangeForAllPriceRows } from "./FetchActualChangeForAllPriceRows";

export const raisePricesUsingSelectionThunk =
  (
    formModel: BulkUpdateRatesFormModel,
    tableContext: TableContext<BulkEditRatesTableColumn>
  ): AppThunk =>
  async (dispatch, getState) => {
    const tableState = getState().bulkEditRatesState;
    const selectedPricesIds =
      getState().bulkEditRatesTableState.standardTable.selectedIds.selectedIds;

    selectedPricesIds.forEach((routeAgreementPriceId) => {
      const standardTableStateForRa =
        tableState.edited[routeAgreementPriceId]?.routeAgreement;
      if (!standardTableStateForRa) {
        return;
      }

      raisePriceForRouteAgreementPrice(
        dispatch,
        routeAgreementPriceId,
        tableState,
        formModel
      );
    });

    fetchBulkEditRatesActualChangeForAllPriceRows(
      dispatch,
      tableContext,
      getState
    );
  };
